var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';
import { useOkapiKy, useStripes } from '@folio/stripes/core';
import { Callout, Loading, MessageBanner, Button, Layout, Pane, AccordionSet, Accordion, KeyValue, } from '@folio/stripes/components';
import useRecordDetail from '../../hooks/useRecordDetail';
import { fetchSingleRecordExport } from '../../api/recordService';
import useAllowedProposalActions from '../../hooks/useAllowedProposalActions';
import MetadataSection from './MetadataSection';
import OpenProposalsBanner from './OpenProposalsBanner';
import OpenErrorReportsBanner from './OpenErrorReportsBanner';
import MarcDataDisplay from './MarcDataDisplay';
import MapLinks from './MapLinks';
import SkosViewer from './SkosViewer';
import RecordHistoryPanel from './RecordHistoryPanel';
import { ValidationPanel } from '../Validation/ValidationPanel';
import { recordToMarc } from '../../utils/recordToMarc';
import { editUrlFor, replaceUrlFor } from '../../utils/editUrlFor';
import { canMergeRecord } from '../../utils/replaceAvailability';
import { recordDisplayId } from '../../utils/recordDisplayId';
import { layoutRecordActions, useRecordReviewActions } from '../RecordReviewActions';
import DetailActions from '../DetailActions';
import ReviewThread from '../ReviewThread';
/**
 * The record detail pane, pane included — Autority, Slovníky, Rejstříky and the review
 * queue all show a record through it.
 * Handles loading, error (404 / network), and success states.
 *
 * <p>CZNA-1456 — it renders its own `Pane` because the actions sit in the pane HEADER
 * (`lastMenu`): one primary button and the rest in the Akce menu, as the proposal detail
 * has had since CZNA-778. A host that wrapped this in its `Pane` could not reach that slot.
 */
var RecordDetail = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var id = _a.id, onClose = _a.onClose, paneProps = _a.paneProps;
    var intl = useIntl();
    var history = useHistory();
    var stripes = useStripes();
    var ky = useOkapiKy();
    // CZNA-1617 — the export's failure callout; the `Record<string, any>` ref type is the one
    // Stripes' untyped Callout takes elsewhere in this module.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var calloutRef = React.useRef(null);
    var _m = useRecordDetail(id), record = _m.record, isLoading = _m.isLoading, isError = _m.isError, error = _m.error, refetch = _m.refetch;
    var canCreateProposalOfType = useAllowedProposalActions().canCreateProposalOfType;
    // CZNA-1577 — „Zrušit s náhradou“ leaves this pane for a page; Zpět there returns here, to
    // whichever section (Autority, Slovníky, Rejstříky, the review queue…) shows this pane.
    var location = useLocation();
    var returnTo = "".concat(location.pathname).concat(location.search);
    // Above the early returns: its confirmation must outlive the refetch that follows an action.
    var review = useRecordReviewActions(record, { onActionComplete: function () { return refetch(); }, returnTo: returnTo });
    var renderPane = function (lastMenu, body) { return (React.createElement(Pane, __assign({}, paneProps, { lastMenu: lastMenu, onClose: onClose, dismissible: true }),
        body,
        React.createElement(Callout, { ref: calloutRef }))); };
    if (isLoading) {
        return renderPane(null, React.createElement(Loading, null));
    }
    if (isError) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var is404 = error && typeof error === 'object' && 'response' in error
            && ((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 404;
        if (is404) {
            return renderPane(null, (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent padding-all-gutter" },
                React.createElement("p", null,
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.notFound" })),
                React.createElement("p", { style: { color: '#666' } },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.notFoundDescription" })),
                React.createElement(Button, { onClick: onClose },
                    React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.close" })))));
        }
        return renderPane(null, (React.createElement(Layout, { className: "display-flex flex-direction-column centerContent padding-all-gutter" },
            React.createElement("p", null,
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.loadError" })),
            React.createElement(Button, { onClick: function () { return refetch(); }, style: { marginTop: '8px' } },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.retry" })),
            React.createElement(Button, { onClick: onClose, style: { marginTop: '8px' } },
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.close" })))));
    }
    if (!record) {
        return renderPane(null, null);
    }
    // Direct-edit gating (TASK-070, AR-02 A1, CZNA-1090): the backend computes the
    // action from the exact same permission and scope that guard PUT. Keeping this as
    // returned data, rather than reconstructing roles here, preserves CZNA-598's single
    // source of truth for authorization.
    // The CTA is hidden when the record is merged or deleted (no edit semantics on
    // a tombstone). `redirectedFrom` is the merge tombstone marker on RecordDetail
    // (RecordSummary uses `mergedIntoAuthorityId`), but it is set ONLY for MERGED
    // chains (RecordServiceImpl), never for DELETED records — `record.status` is
    // checked alongside it (CZNA-767) so a deleted record does not still offer
    // "Editovat"/"Navrhnout opravu" buttons that only fail once clicked (edit 404s
    // server-side on `deletedAt != null`; propose 409s on the new target-ACTIVE guard).
    var isEditable = !record.redirectedFrom
        && (record.status === undefined || record.status === 'ACTIVE');
    var canDirectEdit = (_d = (_c = record.actions) === null || _c === void 0 ? void 0 : _c.includes('edit')) !== null && _d !== void 0 ? _d : false;
    // CZNA-767 (blind review) — `record.actions` only ever carries `edit`/`cancel`
    // (RecordServiceImpl#allowedRecordActions), so gating "Navrhnout změnu" on nothing
    // but `!canDirectEdit` showed it to every viewer, including one with neither
    // RECORD_EDIT nor PROPOSAL_CREATE, and — because this pane is shared with
    // VocabulariesList — for a vocabulary term, whose type has no PermissionMatrix
    // entry at all. `canCreateProposalOfType` is the same per-type answer
    // `ProposalCreateFromRecord` and `AuthoritiesList`'s own "new proposal" button
    // already gate on, so this stays the single source of truth rather than a second,
    // looser one.
    var canProposeChange = canCreateProposalOfType(record.type);
    // TASK-159 / AV-01: validation panel. Only authority record types map onto
    // the validator's enum; vocabulary records (VOCABULARY_*) skip the panel.
    // CZNA-181: OLD_PRINT_CITY (prefix pv, MARC 195) is deliberately omitted —
    // old-print imprint cities have no validation rules yet and their validation
    // scope is an open question for NK (CZNA-295). It mirrors the backend
    // exclusion (RecordClass -> OTHER, RULE_TARGET_RECORD_TYPES). Add it here once
    // NK confirms validation is wanted, in lockstep with the backend.
    var VALIDATABLE_TYPES = [
        'PERSONAL', 'CORPORATE', 'MEETING', 'UNIFORM_TITLE',
        'SUBJECT', 'GEOGRAPHIC', 'CHRONOLOGICAL', 'GENRE_FORM', 'CONSPECT_GROUP',
    ];
    var showValidationPanel = VALIDATABLE_TYPES.includes(record.type);
    var validationRecordType = showValidationPanel ? record.type : undefined;
    var cachedValidationStatus = (_e = record.validationStatus) !== null && _e !== void 0 ? _e : 'NOT_VALIDATED';
    var cachedIssues = (_f = record.validationIssues) !== null && _f !== void 0 ? _f : [];
    var marcForRecheck = showValidationPanel ? recordToMarc(record.dataFields) : undefined;
    // DB-064: the destination depends on the record's TYPE, and this pane is generic —
    // AuthoritiesList, VocabulariesList and Headings all render it. It used to hardcode the
    // authorities path, so "Editovat" on a vocabulary term landed in RecordEdit, which has no
    // form config for VOCABULARY_* and renders its config-unavailable error. The
    // /vocabularies/:id/edit screen and its GET endpoint both worked; nothing led to them.
    // editUrlFor is the single definition of that decision — see its docstring for why the two
    // routes are not interchangeable.
    var handleEdit = function () { return history.push(editUrlFor(record)); };
    var handleProposeChange = function () {
        return history.push("/czna-authorities/proposals/new?targetRecordId=".concat(id));
    };
    // TASK-109 (AR-08): the merge action („Zrušit s náhradou“ since CZNA-1531) is offered only for ACTIVE records
    // (a MERGED/DELETED tombstone has no merge semantics) and only when the user holds
    // the merge capability. `hasPerm` is UX-only; the backend enforces 403.
    // CZNA-1531 — and only when the backend offers it: the capability is held by a local
    // supervisor too, whom the merge service refuses on the national file (CZNA-896).
    // CZNA-1577 — the same answer the merge page gives, from one place.
    var canMerge = canMergeRecord(record, function (perm) { return stripes.hasPerm(perm); });
    // CZNA-193 (TASK-150): the SKOS linked-data panel is gated on the new
    // read capability. `hasPerm` is UX-only; the backend enforces 403.
    var canViewSkos = stripes.hasPerm('czna-authorities.records.skos.get');
    // CZNA-1577 — the comparison of both records in full did not fit a dialog (NK, 24. 2. 2026).
    var handleMerge = function () { return history.push({ pathname: replaceUrlFor(record, 'merge'), state: { returnTo: returnTo } }); };
    // CZNA-1617 (UC AR-04) — the round-trip MARCXML of the record shown, the file the list's
    // MARC export makes for a filter matching only it. Reading changes nothing, so unlike the
    // actions above it is offered on a deleted record and behind the merged banner as well
    // (there `record` is the survivor, and that is what gets exported). `hasPerm` is UX-only;
    // the gateway enforces the same permission on GET /records/{id}/export.
    var canExportMarcXml = stripes.hasPerm('czna-authorities.records.export.get');
    var handleExportMarcXml = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, fetchSingleRecordExport(ky, {
                            id: record.id, type: record.type, exportId: record.exportId, authorityId: record.authorityId,
                        })];
                case 1:
                    _c.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _a = _c.sent();
                    (_b = calloutRef.current) === null || _b === void 0 ? void 0 : _b.sendCallout({
                        type: 'error',
                        message: intl.formatMessage({ id: 'ui-czna-authorities.record.exportMarcXml.error' }),
                    });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var exportAction = canExportMarcXml ? {
        exportMarcXml: {
            key: 'exportMarcXml',
            labelId: 'ui-czna-authorities.record.exportMarcXml',
            helpId: 'ui-czna-authorities.record.exportMarcXml.summary',
            onClick: handleExportMarcXml,
        },
    } : {};
    // CZNA-1456 — every action over the record in one list; `layoutRecordActions` picks the
    // primary and orders the menu, the same way the edit footer's menu is ordered.
    var recordActions = isEditable ? __assign(__assign(__assign(__assign({}, review.actions), (canDirectEdit ? {
        edit: {
            key: 'edit',
            labelId: 'ui-czna-authorities.record.edit.button',
            helpId: 'ui-czna-authorities.record.edit.summary',
            onClick: handleEdit,
            testAttributes: { 'data-testid': 'record-edit-button' },
        },
    } : canProposeChange ? {
        proposeChange: {
            key: 'proposeChange',
            labelId: 'ui-czna-authorities.record.edit.proposeChange',
            helpId: 'ui-czna-authorities.record.edit.proposeChange.summary',
            onClick: handleProposeChange,
            testAttributes: { 'data-testid': 'record-propose-button' },
        },
    } : {})), (canMerge && !review.actions.redirect ? {
        merge: {
            key: 'merge',
            labelId: 'ui-czna-authorities.merge.action',
            helpId: 'ui-czna-authorities.merge.action.summary',
            onClick: handleMerge,
            irreversible: true,
            testAttributes: { 'data-testid': 'record-merge-button' },
        },
    } : {})), exportAction) : exportAction;
    var headerActions = (React.createElement(DetailActions, __assign({ id: "record-detail-actions" }, layoutRecordActions(recordActions, { withPrimary: true }), { helpIcon: false })));
    return renderPane(headerActions, (React.createElement("div", null,
        record.redirectedFrom && (React.createElement(MessageBanner, { type: "warning", dismissible: true },
            React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.mergedBanner", values: {
                    authorityId: recordDisplayId({
                        type: record.type,
                        exportId: record.redirectedFrom.exportId,
                        authorityId: record.redirectedFrom.authorityId,
                    }),
                } }))),
        React.createElement(OpenProposalsBanner, { proposals: record.openProposals }),
        React.createElement(OpenErrorReportsBanner, { recordId: record.id }),
        record.reviewStatus === 'CHANGES_REQUESTED' && (((_g = record.reviewThread) === null || _g === void 0 ? void 0 : _g.length) || record.reviewComment) ? (React.createElement(MessageBanner, { type: "warning" },
            React.createElement("strong", null,
                React.createElement(FormattedMessage, { id: "ui-czna-authorities.review.requestChanges.message" })),
            ((_h = record.reviewThread) === null || _h === void 0 ? void 0 : _h.length)
                ? React.createElement(ReviewThread, { items: record.reviewThread })
                : React.createElement("div", null, record.reviewComment))) : null,
        review.element,
        React.createElement(AccordionSet, null,
            showValidationPanel && (React.createElement(ValidationPanel, { validationStatus: cachedValidationStatus, errorCount: (_j = record.validationErrorCount) !== null && _j !== void 0 ? _j : 0, warningCount: (_k = record.validationWarningCount) !== null && _k !== void 0 ? _k : 0, validatedAt: (_l = record.validatedAt) !== null && _l !== void 0 ? _l : null, currentRecord: marcForRecheck, recordType: validationRecordType, cachedIssues: cachedIssues })),
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-authorities.authorities.detail.headings" }) },
                record.headings.map(function (heading) { return (React.createElement("div", { key: heading.id, "data-testid": "record-heading-".concat(heading.id) },
                    React.createElement(KeyValue, { label: intl.formatMessage({ id: "ui-czna-authorities.headingType.".concat(heading.headingType) }), value: React.createElement(React.Fragment, null,
                            heading.headingValue,
                            heading.headingRemainder && (React.createElement(React.Fragment, null,
                                ' ',
                                React.createElement("span", { style: { color: '#666' } }, heading.headingRemainder))),
                            heading.language && (React.createElement(React.Fragment, null,
                                ' ',
                                React.createElement("span", { style: { color: '#999' } }, heading.language)))) }))); }),
                React.createElement(MapLinks, { dataFields: record.dataFields })),
            React.createElement(MetadataSection, { record: record }),
            React.createElement(MarcDataDisplay, { dataFields: record.dataFields }),
            React.createElement(RecordHistoryPanel, { id: record.id }),
            canViewSkos && React.createElement(SkosViewer, { id: record.id })))));
};
export default RecordDetail;
